<template>
  <div :class="layout ? 'nav-md admin' : 'nav-sm admin'">
    <div class="layout container body">
      <div class="main_container">
        <div class="col-md-3 left_col">
          <menu-side-bar @check-menu="checkMenu" />
        </div>
        <!-- /top navigation -->
        <div class="right_col">
          <!-- top navigation -->
          <div class="top_nav admin">
            <menu-top-header />
          </div>
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MenuSideBar from "../components/MenuSideBar";
  import MenuTopHeader from "../components/MenuTopHeader";
  export default {
    components: {MenuTopHeader, MenuSideBar},
    data() {
      return{
        layout: true,
      }
    },
    mounted() {
      let toggleMenu = document.getElementById('menu_toggle');
      toggleMenu.addEventListener('click', this.changeLayout)
    },
    methods: {
      changeLayout() {
        this.layout = !this.layout;
      },
	  checkMenu() {
	    let width = window.innerWidth
		if (width < 991) this.layout = true
	  }
    }
  }
</script>

